<template>
    <div class="d-flex flex-column width-max-600 mx-auto pt-4 pb-5">
        <h2><b-badge variant="light" class="rounded"><feather type="bell" /></b-badge></h2>
        <h4>{{ $t('addYourWebsite') }}</h4>
        <p class="font-size-16">{{ $t('toStartUsingOurPlatformYouMustReportAtLeastOnePage') }}</p>
        <ButtonIcon class="mr-auto" :to="{ name: 'Pages' }">{{ $t('addWebsite') }}</ButtonIcon>
    </div>
</template>



<script>
    export default {
        name: 'AddFirstSpace',
        data() {
            return {};
        },
    };
</script>
